import { useQuery } from '@tanstack/react-query';

import { fetchRequest, usePrepareRequest } from '../helpers';
import { PHRASE } from '../constants';
import { type Locale } from '../../store/i18nSlice';
import { type Translation } from '../../utils/i18n/types';
import { type WebServiceError } from '../../utils/apis/WebServiceError';

export function useGetTranslationsQuery(locale?: Locale) {
  const { headers, endpoint } = usePrepareRequest({ serviceApi: PHRASE });

  const queryFn = () => {
    if (!locale) {
      throw new Error('A locale is required to fetch translations');
    }

    const { language, country } = locale;

    return fetchRequest<Translation>({
      headers,
      url: `${endpoint}/translations/${language.toLowerCase()}-${country.toUpperCase()}`,
    });
  };

  return useQuery<Translation, WebServiceError>({
    queryKey: ['translations', locale?.language, locale?.country],
    queryFn,
    enabled: Boolean(locale),
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
